import React from 'react';

import ListAssetCard from 'assets/images/listAssetCard.svg';
import PriceIcon from 'assets/icons/priceIcon.svg';
import DeleteIcon from 'assets/icons/delete-icon.svg';
import EditIcon from 'assets/icons/edit-icon.svg';

interface AssetCardProp {
  propertyId?: string;
  propertySlug: string;
  img: any;
  title: string;
  description: string;
  price?: string;
  favourite: boolean;
  address?: string;
}

const AssetListCard = ({
  propertyId,
  propertySlug,
  img,
  title,
  description,
  price,
  favourite,
  address,
}: AssetCardProp) => {
  const wales = 0;
  return (
    <div className="grid grid-cols-ourTable gap-3 bg-gray-4 p-2 sm:p-8 rounded-xl mt-8">
      <div className="flex sm:items-center sm:align-center flex-col sm:flex-row">
        <img src={img} alt="" className="w-10" />
        <p className="text-white text-base whitespace-normal sm:ml-4 mt-2 sm:mt-0">
          {title}
        </p>
      </div>

      <p className="text-grey-rgba whitespace-normal">{description}</p>

      {/* <div className="flex items-start">
        <img className="mr-1 mt-1" src={PriceIcon} alt="" />
        <p className="text-white">
          1,157,400 <br />
          (750,000 USDC){' '}
        </p>
      </div> */}

      <div className="flex justify-around items-center  flex-col sm:flex-row">
        <button className="bg-black text-white border border-primary-2 px-4 py-2 rounded">
          List Asset +
        </button>

        <div className="flex justify-between">
          <img className="w-5 h-5" src={DeleteIcon} alt="" />

          <img className="w-5 h-5" src={EditIcon} alt="" />
        </div>
      </div>
    </div>
  );
};

export default AssetListCard;
